import { takeLatest, call, put  } from "@redux-saga/core/effects";
import { fetchUserCommission, setUserCommission, withdrawCommission } from '../slices/commissionSlice'
import { fetchAffInfo } from '../slices/affiliateSlice'
import { commissionApi } from '../../api/'
import {  
    showModaStatus,
    ModalStatusState
} from '../slices/modalStatusSlice'


export function* onFetchUserCommissions(action: any) {
  try {
    const walletAddress: string = action.payload
    const res:any = yield call(commissionApi.getInfo, walletAddress)

    const { totalProfit, userCommissions } = res

    const mockProfit: number = 3
    const mockUserCommissions: Array<{ address: string, profit: number}> = [
      {address: '0x1', profit: 10 }
    ]
    yield put(setUserCommission({
        totalProfit: mockProfit, 
        userCommissions: mockUserCommissions
    }))

  } catch (ex) {
    console.log(ex)
  }
}

export function* onWithdrawCommission() {



  try {


 
      const res:any = yield call(commissionApi.withdrawCommission)
      yield put(fetchAffInfo())
      const SUCCESS :ModalStatusState ={
        isShowModalStatus: true,
        title: "Request submited",
        msg: "",
        contentType: "success",
        icon: "",
    }

      yield put(showModaStatus(SUCCESS))
    
  } catch (ex) {
    console.log(ex)

    const FAIL :ModalStatusState ={
        isShowModalStatus: true,
        title: "Request failed please try again",
        msg: "",
        contentType: "fail",
        icon: "",
    }
    yield put(showModaStatus(FAIL))
  }
}

// Individual expoxts for testing
export default function* watchSaga() {
  yield takeLatest(fetchUserCommission.type, onFetchUserCommissions);
  yield takeLatest(withdrawCommission.type, onWithdrawCommission);
}